module.exports = __webpack_public_path__ + "static/payment-f38d5c204bd328d56a8f5e7dda607312.png";